import { licensing } from "@/content/site";
import { licensingExamples } from "@/content/caseStudies";
import usePageMeta from "@/hooks/usePageMeta";
import { PageHero } from "@/components/sections/PageHero";
import { DealFlow } from "@/components/sections/DealFlow";
import { ExampleCards } from "@/components/sections/ExampleCards";
import { PartnerPaths } from "@/components/sections/PartnerPaths";
import { CdmoSection } from "@/components/sections/CdmoSection";
import { SectionHeader } from "@/components/common/SectionHeader";
import { Reveal } from "@/components/motion/Reveal";

export default function Licensing() {
  usePageMeta(licensing.meta);
  return (
    <>
      <PageHero hero={licensing.hero} testId="licensing-hero" />

      <section className="section-y border-t border-line" data-testid="licensing-model">
        <div className="container-x">
          <SectionHeader eyebrow="The SPC model" title="In-license. Sublicense. Support to launch." className="mb-14" />
          <div className="grid gap-x-8 gap-y-12 md:grid-cols-3">
            {licensing.model.map((m, i) => (
              <Reveal key={m.title} delay={i * 0.08} className="border-t border-ink/80 pt-6" data-testid={`licensing-model-${i}`}>
                <span className="font-mono text-[13px] text-accent">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 font-display text-3xl font-semibold tracking-[-0.03em] text-ink">{m.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-muted">{m.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-y border-t border-line bg-surface/60" data-testid="licensing-deal-flow">
        <div className="container-x">
          <SectionHeader eyebrow="Deal flow" title="How value moves from lab to patient." className="mb-14" />
          <DealFlow flow={licensing.flow} />
        </div>
      </section>

      <CdmoSection />

      <section className="section-y border-t border-line" data-testid="licensing-examples-section">
        <div className="container-x">
          <SectionHeader {...licensing.examplesIntro} className="mb-14" />
          <ExampleCards items={licensingExamples} />
        </div>
      </section>

      <section className="section-y border-t border-line" data-testid="partner-with-spc">
        <div className="container-x">
          <SectionHeader eyebrow="Partner with SPC" title="Which side of the bridge are you on?" className="mb-14" />
          <PartnerPaths paths={licensing.paths} />
        </div>
      </section>
    </>
  );
}
